import {
  IconCautionSign,
  IconCheckmark,
  IconCircleWheelchair,
  IconClock,
  IconHouserules,
} from "icons";

export const policies = [
  {
    name: "checkInCheckOut",
    Icon: IconClock,
    title: "listing:bookingPolicies.checkInCheckOut.title",
    description: "listing:bookingPolicies.checkInCheckOut.description",
  },
  {
    name: "accessibilityInfo",
    Icon: IconCircleWheelchair,
    title: "listing:bookingPolicies.accessibility.title",
  },
  {
    name: "houseRules",
    Icon: IconHouserules,
    title: "listing:bookingPolicies.houseRules.title",
  },
  {
    name: "homeTruths",
    Icon: IconCautionSign,
    title: "listing:bookingPolicies.homeTruths.title",
  },
  {
    name: "flexibleCancellation",
    Icon: IconCheckmark,
    title: "listing:bookingPolicies.flexCancellation.title",
    description: "listing:bookingPolicies.flexCancellation.message",
  },
];
